class HoverVariantTabs {
    constructor(element) {
      this.element = element;
      this.tabs = this.element.querySelectorAll('[data-tab-target]');
      this.accordionHeaders = this.element.querySelectorAll('[data-accordion-trigger]');
      this.panels = this.element.querySelectorAll('[data-variant-panel]');
      this.isMobile = window.matchMedia('(max-width: 768px)').matches;
      
      this.bindEvents();
      this.handleResize();
    }

    bindEvents() {
      // Desktop tab clicks
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });

      // Mobile accordion clicks
      this.accordionHeaders.forEach(header => {
        header.addEventListener('click', () => this.toggleAccordion(header));
      });

      // Handle resize events
      window.addEventListener('resize', () => this.handleResize());
    }

    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.matchMedia('(max-width: 768px)').matches;
      
      // Reset panels if switching between mobile and desktop
      if (wasMobile !== this.isMobile) {
        this.resetPanels();
      }
    }

    resetPanels() {
      // Find the first active panel
      const activePanel = this.element.querySelector('.hover-variant-tabs__panel.is-active');
      const activeVariantId = activePanel ? activePanel.id.replace('variant-', '') : null;
      
      if (activeVariantId) {
        if (this.isMobile) {
          // Set accordion state
          this.accordionHeaders.forEach(header => {
            const isActive = header.dataset.variantId === activeVariantId;
            header.classList.toggle('is-active', isActive);
            header.setAttribute('aria-expanded', isActive);
          });
        } else {
          // Set tab state
          this.tabs.forEach(tab => {
            const isActive = tab.dataset.variantId === activeVariantId;
            tab.classList.toggle('is-active', isActive);
          });
        }
      }
    }

    switchTab(selectedTab) {
      // Remove active state from all tabs
      this.tabs.forEach(tab => tab.classList.remove('is-active'));
      
      // Add active state to selected tab
      selectedTab.classList.add('is-active');
      
      // Hide all panels
      this.panels.forEach(panel => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });
      
      // Show selected panel
      const targetId = selectedTab.dataset.tabTarget;
      const targetPanel = this.element.querySelector(`#${targetId}`);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        targetPanel.setAttribute('aria-hidden', 'false');
      }
      
      // Swipe gallery to the variant image
      const variantId = selectedTab.dataset.variantId;
      if (variantId && typeof DB_ProductMediaGallery !== 'undefined' && DB_ProductMediaGallery.swipeToVariant) {
        // Small delay to ensure gallery is ready
        setTimeout(() => {
          DB_ProductMediaGallery.swipeToVariant(variantId);
        }, 100);
      }
    }

    toggleAccordion(selectedHeader) {
      const variantId = selectedHeader.dataset.variantId;
      const targetPanel = this.element.querySelector(`#variant-${variantId}`);
      const isCurrentlyActive = selectedHeader.classList.contains('is-active');
      
      // Close all accordions
      this.accordionHeaders.forEach(header => {
        header.classList.remove('is-active');
        header.setAttribute('aria-expanded', 'false');
      });
      
      this.panels.forEach(panel => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
        panel.style.maxHeight = null;
      });
      
      // If the clicked accordion wasn't active, open it
      if (!isCurrentlyActive && targetPanel) {
        selectedHeader.classList.add('is-active');
        selectedHeader.setAttribute('aria-expanded', 'true');
        targetPanel.classList.add('is-active');
        targetPanel.setAttribute('aria-hidden', 'false');
        
        // Calculate and set actual height for smooth animation
        const panelHeight = targetPanel.scrollHeight;
        targetPanel.style.maxHeight = panelHeight + 'px';
        
        // Swipe gallery to the variant image
        if (variantId && typeof DB_ProductMediaGallery !== 'undefined' && DB_ProductMediaGallery.swipeToVariant) {
          // Small delay to ensure gallery is ready
          setTimeout(() => {
            DB_ProductMediaGallery.swipeToVariant(variantId);
          }, 100);
        }
      }
    }
  }

  // Initialize all variant tab components
  document.addEventListener('DOMContentLoaded', () => {
    const variantTabs = document.querySelectorAll('[data-component="hover-variant-tabs"]');
    variantTabs.forEach(element => new HoverVariantTabs(element));
  });